/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AdminGetViewupPlusSnsAccountViewingTypeDto } from './admin-get-viewup-plus-sns-account-viewing-type-dto';
// May contain unused imports in some cases
// @ts-ignore
import type { SnsAccount } from './sns-account';
// May contain unused imports in some cases
// @ts-ignore
import type { ViewupPlusSnsAccountsCounts } from './viewup-plus-sns-accounts-counts';

/**
 * 
 * @export
 * @interface AdminGetViewupPlusSnsAccountsDataDto
 */
export interface AdminGetViewupPlusSnsAccountsDataDto {
    /**
     * 리그램 여부
     * @type {boolean}
     * @memberof AdminGetViewupPlusSnsAccountsDataDto
     */
    'isRegram'?: boolean;
    /**
     * 승인 상태
     * @type {string}
     * @memberof AdminGetViewupPlusSnsAccountsDataDto
     */
    'approvalStatus': AdminGetViewupPlusSnsAccountsDataDtoApprovalStatusEnum;
    /**
     * sns 계정
     * @type {SnsAccount}
     * @memberof AdminGetViewupPlusSnsAccountsDataDto
     */
    'snsAccount': SnsAccount;
    /**
     * 
     * @type {Array<ViewupPlusSnsAccountsCounts>}
     * @memberof AdminGetViewupPlusSnsAccountsDataDto
     */
    'viewupPlusSnsAccountsCounts': Array<ViewupPlusSnsAccountsCounts>;
    /**
     * 
     * @type {Array<AdminGetViewupPlusSnsAccountViewingTypeDto>}
     * @memberof AdminGetViewupPlusSnsAccountsDataDto
     */
    'viewupPlusSnsAccountAutoTypes': Array<AdminGetViewupPlusSnsAccountViewingTypeDto>;
}

export const AdminGetViewupPlusSnsAccountsDataDtoApprovalStatusEnum = {
    Pending: 'pending',
    Waiting: 'waiting',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type AdminGetViewupPlusSnsAccountsDataDtoApprovalStatusEnum = typeof AdminGetViewupPlusSnsAccountsDataDtoApprovalStatusEnum[keyof typeof AdminGetViewupPlusSnsAccountsDataDtoApprovalStatusEnum];


